import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';


import { openDrawer } from './../../../store/slice/MenuSlice';
import CompositiontemplatePageImpl from './CompositiontemplatePageImpl';

export default function CompositiontemplatePage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':true}));
    },[]);

    return (
        < CompositiontemplatePageImpl />
    )

}